import React, { Component } from 'react';
import _ from "lodash";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import auth from "../../services/authService";
import { getDepartmentList } from "../../services/departmentService";
import { messages } from "../../utils/language-en.json";
import { PageWrapperHeight } from '../../utils/LayoutSizes';
import { getVenues, deleteVenue } from '../../services/venuesService';
import DeleteConfirmation from '../Common/delete-confirmation/deleteConfirmation';
import Pagination from '../Common/pagination/pagination';
import SearchBox from "../Common/searchBox";
import VenuesList from './venuesList';
import FilterByDepartment from "../Common/filters/FilterByDepartment";
import "./venues.scss";

class Venues extends Component {
  mounted = false;

  state = {
    dataLoading: true,
    departments: [],
    venues: [],
    filterDepartment: [],
    currentPage: 1,
    pageSize: 10,
    sortColumn: { path: "name", order: "asc"},
    searchQuery: "",
    totalCount: 0,
    deleteItemSelected : []
  }

  async componentDidMount() {
    this.mounted = true;
    const { data: resDepartments } = await getDepartmentList();
    const sortDepartments = _.orderBy(resDepartments.department, ['name'], ['asc']);
    const departments = sortDepartments;

    const userData = auth.getCurrentUser();
    const userDepartmentId = userData.department_id;
    if (userDepartmentId) {
      this.setState({ filterDepartment: [userDepartmentId], currentPage: 1 });
    } else {
      this.setState({ filterDepartment: [], currentPage: 1 });
    }

    this.mounted && this.setState({ departments });
    this.mounted && this.populateVenues();
    this.setState({ pageWrapperHeight: PageWrapperHeight() });
    window.addEventListener('resize', this.updatePageWrapperHeight);
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener('resize', this.updatePageWrapperHeight);
  }

  updatePageWrapperHeight = () => {
    this.setState({ pageWrapperHeight: PageWrapperHeight() });
  };

  populateVenues = async () => {
    try {
      const { data } = await getVenues({
        DEPARTMENT_ID: this.state.filterDepartment,
        LIMIT: this.state.pageSize,
        PAGE: this.state.currentPage,
        ORDER_BY: this.state.sortColumn.path,
        SORT_ORDER: this.state.sortColumn.order,
        SEARCH: this.state.searchQuery
      });
      this.setState({
        venues: data.venue, 
        totalCount: data.count,
        dataLoading: false
      });
    } catch (error) { }
  }

  handleSearch = async query => {
    await this.setState({ searchQuery: query, currentPage: 1 });
    this.populateVenues();
  };
  
  handleDepartmentChange = async (itemSelected) => {
    const departmentSelected = itemSelected ? itemSelected.map((department) => department.value) : [];
    await this.setState({ filterDepartment: departmentSelected, currentPage: 1 });
    this.populateVenues();
  };

  handleSort = async sortColumn => {
    await this.setState({ sortColumn });
    this.populateVenues();
  };

  handlePageChange = async page => {
    await this.setState({ currentPage: page });
    this.populateVenues();
  };

  openModalDeleteConfirmation = item => {
    this.setState({ deleteConfirmationModalIsOpen: true, deleteItemSelected: item });
  }

  closeModalDeleteConfirmation = () => {
    this.setState({ deleteConfirmationModalIsOpen: false, deleteItemSelected: [] });
  }

  handleDelete = async () => {
    const item = this.state.deleteItemSelected;
    const originalVenues = this.state.venues;
    const venues = originalVenues.filter(m => m.id !== item.id);
    this.setState({ venues, deleteConfirmationModalIsOpen: false, deleteItemSelected:[] });

    try {
      const { data } = await deleteVenue(item.id);
      const success = data.success;
      if (!success) {
        const errorMessage = data.message;
        toast.error(errorMessage);
        this.setState({ venues: originalVenues });
        return
      }
      toast.success(messages.success.venueDeleted, { autoClose: 1000 });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error(messages.error.venuesReadyDeleted);

      this.setState({ venues: originalVenues });
    }
  };

  render() {
    const {
      dataLoading, 
      departments, 
      venues,
      pageSize, 
      currentPage, 
      sortColumn, 
      searchQuery,
      totalCount,
      deleteConfirmationModalIsOpen, 
      deleteItemSelected, 
      pageWrapperHeight
    } = this.state;
    const { user } = this.props;
    const authPermissions = auth.getCurrentUserPermisions();

    return (
      <main className="venues-page page-wrapper container-fluid" style={{minHeight: pageWrapperHeight + "px"}}>
        <section className="page-header">
          <div className="row">
            <div className="col">
              <h1 className="page-title"><i aria-hidden="true" className="fas fa-location-arrow"></i>&nbsp;Venues</h1>
            </div>
            <div className="col text-right">
              {authPermissions["module_venues_add"] &&
                <Link
                  to="/venues/create/"
                  className="btn btn-primary"
                >
                  Add Venue
                </Link>
              }
            </div>
          </div>
        </section>
        <section className="page-body">
          <section className="table-console d-flex justify-content-between">
            <div className="table-console-left">
              <div className="table-console-left d-flex align-items-end justify-content-center">
                <FilterByDepartment
                  departments={departments}
                  handleDepartmentChange={this.handleDepartmentChange}
                />
              </div>
            </div>
            <div className="table-console-left d-flex">
              <div className="search">
                <SearchBox value={searchQuery} onChange={this.handleSearch} />
              </div>
            </div>
          </section>
          <VenuesList
            data={ venues }
            user={ user }
            sortColumn={sortColumn}
            onSort={this.handleSort}
            onDelete={this.openModalDeleteConfirmation}
            isLoading={ dataLoading }
          />
          { !dataLoading && (
            <Pagination
              itemsCount={totalCount}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={this.handlePageChange}
            />
          )}
          <DeleteConfirmation
            isOpen={deleteConfirmationModalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModalDeleteConfirmation}
            closeModal={this.closeModalDeleteConfirmation}
            itemName={deleteItemSelected.name}
            onDelete={this.handleDelete}
          />
        </section>
      </main>
    );
  }
}

export default Venues;